import classNames from 'classnames';
import { Upload1Icon } from 'tdesign-icons-react';
import { Button } from 'tdesign-react';

import { Video3, Video4 } from '@/components/icon';
import { VIDEO_ALERT } from '@/const/form';
import { ActionType, ChangeMediaType, EventType } from '@/const/mission';
import { IEvents } from '@/interface';
import { RichMediaValue } from '@/interface/media';
import UploadVideo from '@/material/form-upload/video';

import styles from '../index.module.less';

interface IProps {
  contentEventIdColWidth?: number | undefined;
  value: IEvents;
  disabled: boolean;
  isHorizontal?: boolean;
  onChange: (value: any) => void;
}

const VideoItem: React.FC<IProps> = (props) => {
  const { value, onChange, disabled, isHorizontal = false } = props;
  const isBG = value?.action?.changeMedia?.type === ChangeMediaType.CHANGE_MEDIA_TYPE_BACKGROUND_VIDEO;

  const handleChange = (data: RichMediaValue) => {
    if (disabled) return;
    const videoData = isBG ? { backgroundVideo: data } : { fullVideo: data };
    const postData: IEvents = {
      type: EventType.EVENT_TYPE_ACTION,
      action: {
        type: ActionType.ACTION_TYPE_CHANGEMEDIA,
        changeMedia: {
          ...value?.action?.changeMedia,
          type:
            value?.action?.changeMedia?.type
            || ChangeMediaType.CHANGE_MEDIA_TYPE_FULL_VIDEO,
          ...videoData,
        },
      },
    };
    onChange(postData);
  };

  const uiOptions = {
    isShowRichMedia: true,
    maxCount: 1,
    dialogConfig: {
      width: 370,
      height: 600,
      overflow: 'auto',
    },
    width: 316,
    height: 372,
    contentStyle: { width: '100%', maxWidth: 'auto', overflow: 'scroll' },
    alertRender: VIDEO_ALERT,
    isHorizontal,
    childRender: ({ url, name }: Record<string, string>) => {
      if (!url) {
        return (
          <Button
            size="small"
            theme="default"
            disabled={disabled}
            className={styles.imageButton}
            style={{ height: 32 }}
            icon={<Upload1Icon />}
          >
            点击上传视频
          </Button>
        );
      }
      return <div className="t-input">{name}</div>;
    },
  };

  const videoValue = isBG
    ? value?.action?.changeMedia?.backgroundVideo || {}
    : value?.action?.changeMedia?.fullVideo || {};

  return (
    <div className={styles.itemBox}>
      <div className={classNames(styles.system, styles.leftType, 'draggable')}>
        {isBG ? <Video4 /> : <Video3 />}
        <span className={styles.label}>{isBG ? '背景视频' : '视频'}</span>
      </div>
      <div className={styles.contentBox}>
        <UploadVideo
          disabled={disabled}
          onChange={handleChange}
          asyncUploadOnChange={handleChange}
          value={videoValue}
          className={styles.flex1}
          {...(uiOptions as any)}
          hasEditBtn={false}
        />
      </div>
    </div>
  );
};

export default VideoItem;
